import React from 'react'
import styled from '@emotion/styled'
import {Color, ZIndex} from '../Styles'

export type MBLoadingOverlayProps = {
  open: boolean
}

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${ZIndex.LoadingOverlay};
  width: 100vw;
  height: 100vh;
  background: ${Color.BlackOpacity};
  opacity: ${({open}: MBLoadingOverlayProps): string => open ? '1' : '0'};
  visibility: ${({open}: MBLoadingOverlayProps): string => open ? 'visible' : 'hidden'};
  transition: .3s linear;`

export const MBLoadingOverlay: React.VFC<MBLoadingOverlayProps> = (props) => {
  return (
    <StyledOverlay open={props.open}/>)
}
